let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("45DRC")).then(() => parcelRequire('gXTNd'));